module.exports = __webpack_public_path__ + "img/pause-circle.124fac65.svg";